function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
class TrackingConsent {
  safeGtag(...args) {
    if (typeof gtag === "function") {
      gtag(...args);
    }
  }

  constructor() {
    var __trackingConsent = undefined;
    try {
      Object.defineProperty(window.Shopify, "trackingConsent", {
        get: function () {
          return __trackingConsent || window.Shopify.customerPrivacy;
        },
        set: (val) => {
          __trackingConsent = val;
          var ok = val.getTrackingConsent();
          console.log("__trackingConsent set---->", ok);
          if (ok != "yes") {
            this.safeGtag("consent", "default", {
              ad_storage: "denied",
              ad_user_data: "denied",
              ad_personalization: "denied",
              analytics_storage: "denied",
            });
          }
        },
      });
    } catch (error) {
      console.log("TrackingConsent error---->", error);
    }
    if (
      window.Shopify.trackingConsent &&
      window.Shopify.trackingConsent.getTrackingConsent
    ) {
      var ok = window.Shopify.trackingConsent.getTrackingConsent();
      if (ok != "yes") {
        this.safeGtag("consent", "default", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
        });
      }
    }

    document.body.addEventListener("click", (event) => {
      if (
        event.target.matches(
          "#shopify-pc__banner__btn-accept,#shopify-pc__prefs__header-accept"
        )
      ) {
        console.log("shopify accept");
        this.safeGtag("consent", "update", {
          ad_user_data: "granted",
          ad_personalization: "granted",
          ad_storage: "granted",
          analytics_storage: "granted",
        });
      }
    });

    document.body.addEventListener("click", function (event) {
      if (event.target.matches("#shopify-pc__banner__btn-manage-prefs")) {
        const marketing = document.querySelector(
          "#shopify-pc__prefs__marketing"
        );
        const marketingInput = marketing.querySelector("input");
        const marketingSvgs = marketing.querySelectorAll("svg");
        marketingInput.checked = true;
        marketingSvgs[0].style.display = "block";
        marketingSvgs[1].style.display = "none";

        const analytics = document.querySelector(
          "#shopify-pc__prefs__analytics"
        );
        const analyticsInput = analytics.querySelector("input");
        const analyticsSvgs = analytics.querySelectorAll("svg");
        analyticsInput.checked = true;
        analyticsSvgs[0].style.display = "block";
        analyticsSvgs[1].style.display = "none";

        const preferences = document.querySelector(
          "#shopify-pc__prefs__preferences"
        );
        const preferencesInput = preferences.querySelector("input");
        const preferencesSvgs = preferences.querySelectorAll("svg");
        preferencesInput.checked = true;
        preferencesSvgs[0].style.display = "block";
        preferencesSvgs[1].style.display = "none";
      }
    });

    document.body.addEventListener("click", (event) => {
      if (event.target.matches("#shopify-pc__prefs__header-save")) {
        console.log("shopify save");
        var data = {
          ad_user_data: "granted",
          ad_personalization: document.querySelector(
            "#shopify-pc__prefs__preferences-input"
          ).checked
            ? "granted"
            : "denied",
          ad_storage: document.querySelector(
            "#shopify-pc__prefs__marketing-input"
          ).checked
            ? "granted"
            : "denied",
          analytics_storage: document.querySelector(
            "#shopify-pc__prefs__analytics-input"
          ).checked
            ? "granted"
            : "denied",
        };
        console.log("shopify save", data);
        this.safeGtag("consent", "update", data);
      }
    });
  }
}
// 处理 FAQ 功能  /pages/order
function faqFunc() {
  // 设置FAQ标题颜色
  document.querySelectorAll(".click_title").forEach((element) => {
    if (element.textContent.trim() === "FAQ") {
      element.style.color = "#eb5148";
    }
  });
  document.querySelectorAll(".question_main").forEach((question) => {
    question.addEventListener("click", function (event) {
      const questionContent = event.target.closest(".question_content");
      if (questionContent) {
        const que = questionContent.querySelector(".question_que");
        if (que) {
          que.classList.toggle("active");
        }
      }
    });
  });
}
class FooterEvent {
  constructor() {
    const dom = document.querySelectorAll(".footer .footer__block--menu");

    dom.forEach((item) => {
      item.addEventListener("click", function (e) {
        const target = e.target;
        const _this = target.closest(".footer__block--menu");
        if (_this) {
          _this.querySelector(".link__ul").classList.toggle("active");
          const button = _this.querySelector(".plus-button");
          if (button) {
            button.innerText = button.innerText === "+" ? "-" : "+";
          }
        }
      });
    });
  }
}
function init() {
  new TrackingConsent();
  new FooterEvent();
  hdAdp();
  const first_flags = document.querySelector(".first_flags");
  const second_flags = document.querySelector(".second_flags");
  if (first_flags) {
    first_flags.addEventListener("click", function (e) {
      second_flags.classList.toggle("active");
    });
  }
  faqFunc();
  document.querySelectorAll(".r-goto").forEach((item) => {
    item.addEventListener("click", function (e) {
      const target = e.target;
      console.log(target, "target");

      const url = target.closest(".r-goto").dataset.target;
      // 跳转到 #plugin_features
      if (url) {
        const targetElement = document.querySelector("#" + url);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });
  document.querySelectorAll(".goto-link").forEach((item) => {
    item.addEventListener("click", function (e) {
      const target = e.target.closest(".goto-link");
      const gotoLink = target.dataset.gotoLink;
      if (gotoLink) {
        // 如果有 gotoLink 属性，跳转到指定链接
        window.location.href = gotoLink;
      }
    });
  });
  // 处理产品页的浮动筛选按钮
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target.classList.contains("facet-type")) {
      const dom = document.querySelector(".facet-floating-filter__button");
      if (dom) {
        dom.click();
      }
    }
  });
}

function ready(callback) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}
ready(init);

function hdAdp() {
  if (!window.location.pathname.includes("/collections/")) {
    return;
  }
  function getUrlAdp() {
    const searchParams = new URLSearchParams(window.location.search);
    const adpParam = searchParams.get("adp");
    return adpParam ? decodeURIComponent(adpParam) : "";
  }
  const adpValue = getUrlAdp();
  if (adpValue) {
    const handles = adpValue ? adpValue.split(",") : [];
    const productList = document.querySelector(".product-list");
    if (handles.length && productList) {
      const productItems = Array.from(
        productList.querySelectorAll(".product-card")
      );

      if (productItems.length <= 1) return; // 无需重排

      const firstItem = productItems[0];

      // 按handles顺序收集需要前置的产品
      const preItems = handles.flatMap((handle) =>
        productItems.filter(
          (item) => item.getAttribute("handle") === handle && item !== firstItem
        )
      );

      // 从原位置移除并重新插入
      preItems.forEach((item) => {
        if (item.parentNode === productList) {
          productList.removeChild(item);
          productList.insertBefore(item, firstItem);
        }
      });
    }
  }
}

// webcomponent 继承一个 button
// 点击 判断是否有 data-variant-id
// 如果有就需要发起请求 并且把 按钮状态改成 loading
class AddToCartButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
    const button__loader = document.createElement("div");
    this.classList.add("add-to-cart");
    button__loader.classList.add("loading-dots");
    button__loader.innerHTML = `<div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>`;
    this.button__loader = button__loader;
  }
  setLoading(isLoading) {
    if (isLoading) {
      this.setAttribute("disabled", "");
      const dom = this.firstElementChild;
      if (dom) {
        dom.style.display = "none";
      }
      this.appendChild(this.button__loader);
    } else {
      this.removeAttribute("disabled");
      const dom = this.firstElementChild;
      if (dom) {
        dom.style.display = "block";
      }
      this.removeChild(this.button__loader);
    }
  }
  async handleClick() {
    const variantId = this.dataset.variantId || this.dataset.variant_id;
    if (!variantId) return;
    try {
      this.setLoading(true);
      // 这里添加你的请求逻辑
      let sectionsToBundle = ["variant-added"];
      const newFormData = new FormData();
      newFormData.append("utf8", "✓");
      newFormData.append("form_type", "product");
      newFormData.append("id", variantId);
      newFormData.append("quantity", 1);
      newFormData.set("sections", sectionsToBundle.join(","));
      newFormData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${variantId}`
      );

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: newFormData,
      });
      const responseJson = await response.json();
      if (response.ok) {
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];
        const data = cartContent.items.find(
          (item) => item.variant_id == variantId
        );
        if (data) {
          this.dispatchEvent(
            new CustomEvent("cart:add", {
              bubbles: true,
              detail: [
                {
                  id: variantId,
                  quantity: 1,
                  sku: data.sku,
                  title: data.title,
                  price: data.price,
                },
              ],
            })
          );
        }
        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson["items"]
                : [responseJson],
              cart: cartContent,
            },
          })
        );
        if (
          window.themeVariables.settings.cartType === "page" ||
          window.themeVariables.settings.pageType === "cart"
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartContent,
            },
          })
        );
      } else {
        this.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"],
            },
          })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      this.setLoading(false);
    }
  }
}

customElements.define("add-to-cart", AddToCartButton, { extends: "button" });

// web components  实现一个 popover 支持 上下左右 控制 弹窗内容用 插槽
// 弹窗 为黑底 需要一个三角形箭头
class PopoverComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.position = this.getAttribute("position") || "bottom";
    this.isOpen = this.hasAttribute("open");

    const style = document.createElement("style");
    style.textContent = `
      :host {
        position: relative;
        display: inline-block;
        --popover-bg: #fff;
        --popover-color: #000;
      }
      .popover {
        position: absolute;
        background: var(--popover-bg);
        color: var(--popover-color);
        padding: 10px;
        border-radius: 4px;
        z-index: 1000;
        display: none;
        width: max-content;
        box-sizing: border-box;
      }
      .popover::before {
        content: '';
        position: absolute;
        border: 8px solid transparent;
      }
      .popover[data-position='top'] {
        bottom: calc(100% + 8px);
        left: 0;
        transform: none;
      }
      .popover[data-position='top-right'] {
        bottom: calc(100% + 8px);
        right: 0;
        transform: none;
      }
      .popover[data-position='top']::before {
        border-top-color: var(--popover-bg);
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      .popover[data-position='top-right']::before {
        border-top-color: var(--popover-bg);
        top: 100%;
        left: 90%;
      }
      .popover[data-position='bottom'] {
        top: calc(100% + 8px);
        left: 0;
        transform: none;
      }
      .popover[data-position='bottom']::before {
        border-bottom-color: var(--popover-bg);
        bottom: 100%;
        left: 10%;
        transform: translateX(-50%);
      }
      .popover[data-position='left'] {
        right: calc(100% + 8px);
        top: 0;
        transform: none;
      }
      .popover[data-position='left']::before {
        border-left-color: var(--popover-bg);
        left: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
      .popover[data-position='left-bottom'] {
            right: 0;
            top: 130%;
            transform: none;
      }
      .popover[data-position='left-bottom']::before {
        border-bottom-color: var(--popover-bg);
        border-left-color: transparent;
        top: -16px;
        right: 5px;
        transform: translateX(-50%);
      }
      .popover[data-position='right'] {
        left: calc(100% + 8px);
        top: 0;
        transform: none;
      }
      .popover[data-position='right']::before {
        border-right-color: var(--popover-bg);
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
    `;

    const template = document.createElement("template");
    template.innerHTML = `
      <div class="trigger">
        <slot name="trigger"></slot>
      </div>
      <div class="popover" data-position="${this.position}">
        <slot></slot>
      </div>
    `;

    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this.triggerElement = this.shadowRoot.querySelector(".trigger");
    this.popoverElement = this.shadowRoot.querySelector(".popover");

    this.triggerElement.addEventListener("click", () => this.toggle());

    // 点击外部关闭弹窗
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target) && this.isOpen) {
        this.hide();
      }
    });

    // 初始化显示状态
    if (this.isOpen) {
      this.show();
    }
  }

  toggle() {
    if (this.isOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.popoverElement.style.display = "block";
    this.isOpen = true;
    this.setAttribute("open", "");
  }

  hide() {
    this.popoverElement.style.display = "none";
    this.isOpen = false;
    this.removeAttribute("open");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "position" && oldValue !== newValue) {
      this.position = newValue;
      this.popoverElement.setAttribute("data-position", newValue);
    } else if (name === "open" && oldValue !== newValue) {
      if (this.hasAttribute("open")) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  static get observedAttributes() {
    return ["position", "open"];
  }
}

customElements.define("rantion-popover", PopoverComponent);


class RantionComparison extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.allProducts = [];
    this.getSelectedIndices();
  }

  getSelectedIndices() {
    // 根据屏幕宽度决定显示几列：PC 3列，移动端 2列
    const cols = window.innerWidth <= 750 ? 2 : 3;
    this.selectedIndices = Array.from({ length: cols }, (_, i) => i);
  }

  connectedCallback() {
    setTimeout(() => {
      // 从 script 标签读取 JSON 数据
      const productsId = this.getAttribute('data-products-id');
      let dataJson = null;
      if (productsId) {
        const scriptEl = document.getElementById(productsId);
        dataJson = scriptEl ? scriptEl.textContent : null;
      }
      try {
        const data = dataJson ? JSON.parse(dataJson) : {};
        this.colKeys = data.colKeys?.split('\n') || [];
        this.allProducts = data.products || [];
      } catch (e) {
        console.error('Failed to parse comparison data:', e);
        this.colKeys = [];
        this.allProducts = [];
      }
      // 兼容旧格式：如果解析出来是数组，说明是旧格式，当作 products 处理
      if (Array.isArray(this.allProducts)) {
        // 已经处理过了，不需要转换
      } else if (Array.isArray(dataJson)) {
        this.allProducts = JSON.parse(dataJson);
      }
      // 预处理 values 为数组
      this.allProducts = this.allProducts.map(p => ({
        ...p,
        values: p.value?.split('\n') || [],
      }));
      // 如果 colKeys 为空，从属性回退读取（兼容旧数据）
      if (this.colKeys.length === 0) {
        this.colKeys = this.getAttribute('colkey')?.split('\\n') || [];
      }
      // 如果 first-id 不为空且在列表中，将其放在第一位
      const firstId = this.getAttribute('first-id') || window.firstId;
      if (firstId) {
        const foundIndex = this.allProducts.findIndex((p) => p.id === firstId);
        if (foundIndex !== -1) {
          this.selectedIndices[0] = foundIndex;
        }
      }
      this.render();
    }, 50);
    // 监听窗口大小变化，重新计算列数并重新渲染
    window.addEventListener('resize', () => {
      const oldCols = this.selectedIndices.length;
      this.getSelectedIndices();
      if (oldCols !== this.selectedIndices.length) {
        // 重新计算 first-id
        const firstId = this.getAttribute('first-id');
        if (firstId) {
          const foundIndex = this.allProducts.findIndex((p) => p.id === firstId);
          if (foundIndex !== -1) {
            this.selectedIndices[0] = foundIndex;
          }
        }
        this.render();
      }
    });
  }

  handleSelectChange(colIndex, event) {
    this.selectedIndices[colIndex] = parseInt(event.target.value);
    this.render();
  }

  render() {
    const colKeys = this.colKeys || [];
    const displayProducts = this.selectedIndices.map((i) =>
      i === -1 ? null : this.allProducts[i] || this.allProducts[0]
    );

    const isFixedHeader = this.getAttribute('fixed-header') === 'true';
    const colCount = this.selectedIndices.length;
    const style = `
      <style>
        :host {
          display: block;
          --border-color: #ededed;
          --text-variant: #71787c;
          --bg-zebra: #f5f7f8;
          --diff-data-cell-padding-y: 32px;
          --diff-data-cell-padding-x: 24px;
          --comparison-max-height: 600px;
          --scrollbar-width: 16px; /* 标准滚动条宽度 */
        }

        .comparison-wrapper {
          border-left: 1px solid var(--border-color);
          border-top: 1px solid var(--border-color);
          border-radius: 6px;
          overflow: hidden;
          width: 100%;
        }

        table.comparison-table {
          border-collapse: collapse;
          width: 100%;
          table-layout: fixed;
        }

        /* 固定表头：整个在一个 table 中，thead 保持不动，tbody 滚动 */
        ${isFixedHeader ? `
        table.comparison-table {
          display: block;
        }
        table.comparison-table thead {
          display: table;
          table-layout: fixed;
        }
        table.comparison-table tbody {
          display: block;
          overflow-y: auto;
          overflow-x: hidden;
          max-height: var(--comparison-max-height);
        }
        table.comparison-table tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;
        }
        /* 只有 PC (>750px) 需要给滚动条留空间 */
        @media (min-width: 750px) {
          table.comparison-table thead {
            width: calc(100% - var(--scrollbar-width));
          }
        }
        ` : `
        table.comparison-table {
          display: table;
        }
        table.comparison-table thead {
          display: table-header-group;
        }
        table.comparison-table tbody {
          display: table-row-group;
        }
        table.comparison-table tbody tr {
          display: table-row;
        }
        `}

        tbody tr:nth-child(even) td {
          background-color: var(--bg-zebra);
        }

        th.product-header {
          padding: 20px;
          text-align: center;
          border-right: 1px solid var(--border-color);
          border-bottom: 1px solid var(--border-color);
          vertical-align: bottom;
          width: calc(100% / ${colCount});
          box-sizing: border-box;
        }

        .product-img {
          width: 100%;
          max-width: 140px;
          aspect-ratio: 1;
          object-fit: contain;
          margin-bottom: 24px;
          cursor: pointer;
        }

        /* 下拉框容器 */
        .select-wrapper {
          position: relative;
          width: 100%;
          max-width: 220px; /* 稍微调宽以适应更大的箭头 */
          background: #fff;
          border-radius: 4px;
          border: 1px solid rgba(0,0,0,0.1);
          padding: 0 16px; /* 增加内边距 */
          display: flex;
          align-items: center;
          transition: border-color 0.2s;
          margin: 0 auto;
          box-sizing: border-box;
        }
        .select-wrapper:hover {
          border-color: rgba(0,0,0,0.3);
        }

        select {
          width: 100%;
          height: 48px; /* 调高以适应更大的箭头 */
          background: transparent;
          border: none;
          font-size: 15px; /* 字体稍微调大一点点 */
          font-weight: 700;
          color: #191c1e;
          cursor: pointer;
          outline: none;
          appearance: none;
          padding-right: 32px; /* 留出足够的空间给粗箭头 */
          text-overflow: ellipsis;
          box-sizing: border-box;
        }

        select option:disabled {
          color: #ccc;
          background-color: #f5f5f5;
        }

        /* 更大、更醒目的粗箭头 */
        .arrow-icon {
          position: absolute;
          right: 16px; /* 与内边距保持一致 */
          width: 20px; /* 明显增大 */
          height: 20px; /* 明显增大 */
          pointer-events: none;
          fill: rgba(0,0,0,0.7); /* 稍微深一点的颜色 */
        }

        /* 数据单元格 */
        td.data-cell {
          padding: var(--diff-data-cell-padding-y, 32px) var(--diff-data-cell-padding-x, 24px);
          border-right: 1px solid var(--border-color);
          border-bottom: 1px solid var(--border-color);
          background: #fff;
          transition: background-color 0.2s;
          vertical-align: top;
          width: calc(100% / ${colCount});
          box-sizing: border-box;
        }
        .label-tag {
          display: block;
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: var(--text-variant);
          margin-bottom: 10px;
          opacity: 0.7;
        }

        .value-text {
          overflow-wrap: break-word;
          word-wrap: break-word; /* 兼容旧版 */
          margin: 0;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.4;
          color: #191c1e;
        }

        .empty-product-img-placeholder {
          width: 100%;
          max-width: 140px;
          aspect-ratio: 1;
          border: 2px dashed #ddd;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          color: #999;
          font-size: 14px;
          background: #fafafa;
        }
      </style>
    `;

    // 换成了一个专门设计的、视觉权重更厚实的粗箭头 SVG
    const boldArrowSvg = `
      <svg class="arrow-icon" viewBox="0 0 24 24">
        <path d="M7 10l5 5 5-5z" />
      </svg>
    `;

    // 获取当前所有已选中的索引（排除当前列）
    const getUsedIndices = (currentColIndex) => {
      return this.selectedIndices.filter((idx, i) => idx !== -1 && i !== currentColIndex);
    };

    let headerHtml = '';
    let bodyHtml = '';

    // 检查是否有 first-id 并且在列表中，第一列是否需要固定
    const firstId = this.getAttribute('first-id');
    const isFirstColumnFixed = firstId && this.allProducts.some((p) => p.id === firstId);

    // 1. 渲染 Header (thead)
    this.selectedIndices.forEach((selectedIdx, colIndex) => {
      const prod = selectedIdx === -1 ? null : this.allProducts[selectedIdx] || this.allProducts[0];
      const used = getUsedIndices(colIndex);
      const isFixed = colIndex === 0 && isFirstColumnFixed;
      headerHtml += `
        <th class="product-header">
          ${prod && prod.img
          ? `<img class="product-img" src="${prod.img}" onclick="window.location.href='${prod.url}'" />`
          : `<div class="empty-product-img-placeholder">No Product</div>`
        }
          <div class="select-wrapper">
            <select ${isFixed ? 'disabled' : ''
        } onchange="this.getRootNode().host.handleSelectChange(${colIndex}, event)">
              ${!isFixed ? `<option value="-1" ${selectedIdx === -1 ? 'selected' : ''}>--</option>` : ''}
              ${this.allProducts
          .map(
            (p, i) => `
                <option value="${i}" ${this.selectedIndices[colIndex] === i ? 'selected' : ''} ${!isFixed && used.includes(i) ? 'disabled' : ''
              }>
                  ${p.name}
                </option>
              `
          )
          .join('')}
            </select>
            ${boldArrowSvg}
          </div>
        </th>`;
    });

    // 2. 渲染数据行 (tbody) - 每一行特性对应一个 <tr>
    colKeys.forEach((key, rowIndex) => {
      let rowCells = '';
      this.selectedIndices.forEach((selectedIdx) => {
        const prod = selectedIdx === -1 ? null : this.allProducts[selectedIdx];
        rowCells += `
          <td class="data-cell">
            <span class="label-tag">${key}</span>
            <p class="value-text">${prod && prod.values[rowIndex] ? prod.values[rowIndex] : '-'}</p>
          </td>`;
      });
      bodyHtml += `<tr>${rowCells}</tr>`;
    });

    this.shadowRoot.innerHTML = `${style}
      <div class="comparison-wrapper">
        <table class="comparison-table">
          <thead>
            <tr>${headerHtml}</tr>
          </thead>
          <tbody>${bodyHtml}</tbody>
        </table>
      </div>
    `;
  }
}

customElements.define('rantion-comparison', RantionComparison);
customElements.define('rantion-comparison-li', class extends HTMLElement { });